import { NgModule } from '@angular/core';
import { CommonModule } from '@nano/common';
import { AlertModule } from '@nano/common/alert';
import { FileUploadModule } from '@nano/common/file';

import { SendMessageModule } from '../shared/send-message/send-message.module';
import { StartMessageThreadComponent } from './start-message-thread.component';

@NgModule({
  imports: [CommonModule, AlertModule, FileUploadModule, SendMessageModule],
  declarations: [StartMessageThreadComponent],
  exports: [StartMessageThreadComponent]
})
export class StartMessageThreadModule {}
